import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';
import { Alert, Snackbar } from '@mui/material';
import { API } from '../../../API';

export default function PayrollTable(props) {
  const data = props.data;
  const [snackbar, setSnackbar] = React.useState(null);
  const columns = [
    {
      field: "state_name",
      headerName: "Campus Location",
      flex: 4,
      editable: false,
      headerAlign: "center",
      type: "text",
      editable: true,
    },
    {
      field: "state_code",
      headerName: "Code",
      flex: 1,
      editable: false,
      align: "center",
      headerAlign: "center",
      type: "text",
      editable: true,
    },
    {
      type: 'number',
      field: "percent",
      headerName: "Percentage(%) of Wages + Super",
      editable: true,
      align: "center",
      headerAlign: "center",
      flex: 2,
    },
  ];

  const updatePayrollTax = (newData, currentData) => {
    if (!newData.percent || newData.percent === 0) {
      setSnackbar({ children: 'Percentage(%) of Wages + Super cannot empty', severity: 'error' });
      return currentData;
    }

    return API.updatePayrollTax(newData._id, newData).then(() => {
      setSnackbar({ children: 'Payroll tax successfully saved', severity: 'success' });
      return newData;
    }).catch(() => {
      setSnackbar({ children: 'Update error', severity: 'error' });
      return currentData;
    });
  }

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleProcessRowUpdateError = React.useCallback((error) => {
    console.log("error on updating: ", error)
    setSnackbar({ children: error, severity: 'error' });
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <DataGrid
          editMode="row"
          rows={data}
          columns={columns}
          hideFooterPagination
          processRowUpdate={(updatedRow, originalRow) => updatePayrollTax(updatedRow, originalRow)}
          onProcessRowUpdateError={handleProcessRowUpdateError}
        />

        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </Paper>
    </Box>
  );
}